import { format } from 'date-fns';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { operationTypeConfig } from 'src/app/ops/config/operation-type-config';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { CardViewModel } from 'src/models/card-view-model';
import { TripLegViewModel_DEPRECATED } from 'src/models/trip-leg-view-model';
import { TripViewModel } from 'src/models/trip-view-model';
import { selectViewModel } from 'src/models/view-model-helper';
import { selectPrimaryTripByCardNumber } from 'src/store/entityStores/trip-selectors';
import { selectCurrentOrNextTripLegByCardNumber_DEPRECATED } from 'src/store/entityStores/tripleg-selectors';
import {
  OperationRecord,
  OperationViewModelBase,
} from 'src/store/generated/operation-record.generated';
import { selectVehicleById, VehicleRecord } from 'src/store/generated/vehicle-record.generated';
import { filterNull } from 'src/util/rxjs/operators/filter-null';
import { humanize } from 'src/util/text';
import { UnitViewModel } from './unit-view-model';

export class OperationViewModel extends OperationViewModelBase {
  public readonly trip$: Observable<TripViewModel | undefined>;
  public readonly vehicle$: Observable<VehicleRecord | undefined>;

  get tripIfExists$(): Observable<TripViewModel> {
    return this.trip$.pipe(filterNull());
  }

  get options() {
    return operationTypeConfig[this.type];
  }

  get statusDisplay(): string {
    return humanize(this.status);
  }

  /**
   * Use TripViewModel.currentOrNextTripLeg$ instead
   */
  get currentOrNextTripLeg_DEPRECATED$() {
    return selectViewModel(
      this._model.store,
      selectCurrentOrNextTripLegByCardNumber_DEPRECATED(this.card.cardNumber),
      (tripLeg) =>
        tripLeg == null ? undefined : new TripLegViewModel_DEPRECATED(tripLeg, this._model),
    );
  }

  get dateOperationStartedDisplay() {
    return format(this.dateOperationStarted, 'MM/dd/yyyy HH:mm');
  }

  constructor(
    operation: OperationRecord,
    public readonly card: CardViewModel,
    public readonly unit: UnitViewModel | undefined,
    private readonly _model: ViewModelService,
  ) {
    super(operation);
    this.trip$ = _model.store
      .select(selectPrimaryTripByCardNumber(this.card.cardNumber))
      .pipe(map((trip) => (trip != null ? new TripViewModel(trip, this, _model) : undefined)));

    this.vehicle$ = _model.store.select(selectVehicleById(this.vehicleId));
  }
}
